import IModel from "../model/applicationForm/IApplicationForm";
import IRequest from "../dto/financing-v1/IApplicationRequest";
import Request from "../dto/financing-v1/ApplicationRequest";
import IApplication from "../model/IApplication";
import Application from "../model/Application";
import IMerchantURLs from "../dto/IMerchantURLs";
import MerchantURLs from "../dto/MerchantURLs";
import CustomerMapper from "@/module/main/service/CustomerMapperV2";
import FinancingType from "@/module/main/dto/FinancingTypeEnum";
import IFinancingSettings from "@/module/main/dto/financing-v1/IFinancingSettings";
import FinancingSettings from "@/module/main/dto/financing-v1/FinancingSettings";
import IOrder from "@/module/main/dto/financing-v1/IOrder";
import Order from "@/module/main/dto/financing-v1/Order";
import Item from "@/module/main/dto/financing-v1/Item";
import HcImage from "@/module/main/dto/financing-v1/HcImage";
import WorkflowStep from "@/module/main/dto/WorkflowStep";
import WorkflowCode from "@/module/main/dto/WorkflowCodeEnum";
import RedirectUrl from "@/module/main/dto/RedirectUrl";
import BaseMapperV1 from "@/module/main/service/BaseMapperV1";
import IEndpoints from "@/module/main/model/applicationForm/IEndpoints";
import IOrderItem from "@/module/main/model/applicationForm/IOrderItem";
import IHcImage from "@/module/main/dto/financing-v1/IHcImage";
import IItem from "@/module/main/dto/financing-v1/IItem";
import ApiName from "@/module/api/service/ApiNameEnum";

class ApplicationV1Mapper extends BaseMapperV1 {

    readonly VERSION: string = 'v1';
    readonly API_NAME: string = ApiName.FINANCING;

    public toCreateRequest(application: IModel): IRequest {
        return new Request(
            this.getOrder(application),
            application.loan.financingType,
            ApplicationV1Mapper.getMerchantUrls(application.endpoints),
            CustomerMapper.getCustomer(application.customer, application.currency.code),
            this.getFinancingSettings(application, FinancingType.INSTALLMENT),
            this.getFinancingSettings(application, FinancingType.CONSUMER_LOAN),
            this.getFinancingSettings(application, FinancingType.GOODS_FINANCING),
        );
    }

    public fromResponse(response: any): IApplication {
        let { customerKey, state, stateReason, id, gatewayRedirectUrl } = response;
        let workflowSteps = [new WorkflowStep(WorkflowCode.REDIRECT, true, 1, new RedirectUrl(gatewayRedirectUrl))];

        return new Application(customerKey, id, state, stateReason, workflowSteps);
    }

    private getOrder(application: IModel): IOrder
    {
        let items: IItem[] = [];
        for (let itemData of application.customer.orderItems)
        {
            let item = new Item(itemData.code, itemData.name, itemData.quantity, itemData.type, itemData.producer, this.createAmount(itemData.totalPrice, application.currency.code),
                this.getHcImage(itemData));
            items.push(item);
        }

        return new Order(application.loan.orderNumber, this.createAmount(application.loan.totalPrice, application.currency.code), items);
    }

    private getHcImage(data: IOrderItem): IHcImage
    {
        return "" === data.imageFileName ?
            new HcImage("iphone6s.jpg", "https://i.cdn.nrholding.net/32523771/2000/2000", undefined) :
            new HcImage(data.imageFileName, undefined, data.image);
    }

    private getFinancingSettings(application: IModel, financingType: FinancingType): IFinancingSettings | undefined {

        if (application.loan.financingType !== financingType)
            return undefined;

        return new FinancingSettings(this.createAmount(application.loan.preferredInstallment, application.currency.code),
            this.createAmount(application.loan.preferredDownPayment, application.currency.code),
            application.loan.productCode,
            application.loan.productSetCode
        );
    }

    private static getMerchantUrls(endpoints: IEndpoints): IMerchantURLs
    {
        return new MerchantURLs(
            endpoints.approvedRedirect || undefined,
            endpoints.notificationEndpoint || undefined,
            endpoints.rejectedRedirect || undefined
        );
    }
}

export default new ApplicationV1Mapper();
